// JS file for OrganizationItem
import u from '@main';

u.$ui.tomSelect('.has-tom-select')

$(() => {
  const collapseForm = $('.org-comment');

  collapseForm.not('.active').hide();

  let score = 4;

  $('.score').starRating({
    totalStars: 5,
    starShape: 'rounded',
    starSize: 30,
    emptyColor: 'lightgray',
    hoverColor: '#ffcc26',
    activeColor: '#ffcc26',
    useGradient: false,
    useFullStars: true,
    disableAfterRate: false,
    callback: function(currentRating){
      score = currentRating;
    }
  });

  const imgSlider = $('.l-org-info__media-group').owlCarousel({
    items: 1,
    margin: 30,
    loop: true,
    autoplay:true,
    autoplayTimeout:10000,
    autoplayHoverPause:true,
    responsive: {
      768: {
        items: 2,
        nav : false,
        dots: false,
      },
      992: {
        items: 3,
        nav : false,
        dots: false,
      }
    }
  });

  $('.j-slider-left').on('click', function () {
    imgSlider.trigger('prev.owl.carousel')
  });

  $('.j-slider-right').on('click', function () {
    imgSlider.trigger('next.owl.carousel')
  });

  const announceSlider = $('.org-announce__body').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dot: false,
    autoplay: true,
    autoplayTimeout:5000,
    autoplayHoverPause:true,
  });

  $('.announceSlider_link').on('click', function () {
    const id = $(this).data('link')
    const key = '#organizationItemModal-' + id;
    $(key).modal('show');
  });

  // department collapse
  let selector = $('.c-custom-select__origin');

  selector.on('change', () => {
    $('.collapse').collapse('hide');

    $('#' + selector.val()).collapse('show')
  })

  $('#expand-comments').on('click', function () {
    $('.org-comment').not('.active').slideToggle();
  })

  collapseForm.on('show.bs.collapse', '.collapse', function() {
    collapseForm.find('.collapse.show').collapse('hide');
  })

  $('.j-open-subcomment').on('click', function () {
    const target = $(this).data('bs-target');

    $(target).toggle(200);

    let attr = $(this).find('svg').attr('data-icon');

    if (attr === 'chevron-down') {
      $(this).find('svg').attr('data-icon', 'chevron-up')
    } else {
      $(this).find('svg').attr('data-icon', 'chevron-down')
    }
  });

  $('.reply-form button[type="submit"]').on('click', async function(event) {
    event.preventDefault();

    const url = u.route('reply_comment');

    const anonymous = $(this).data('anonymous');

    let data = new FormData($(this).closest('form')[0]);

    $(this).find('button').addClass('disabled');

    data.append('anonymous', anonymous);

    try {
      const res = await u.$http.post(
        url,
        data
      );

      location.href = res.data.data;
    } catch (e) {
      console.log(e);
    } finally {
      $(this).find('button').removeClass('disabled');
    }
  })

  $('.post-submit').on('click', async function(event) {
    event.preventDefault();

    $(this).addClass('disabled');

    const url = u.route('post_comment');
    const data = new FormData($('#post-form')[0]);

    data.append('score', score);
    data.append('anonymous', '0');

    if (score <= 0) {
      alert('未填寫分數');
    } else {
      try {
        const res = await u.$http.post(url, data);

        location.href = res.data.data;
      } catch (e) {
        console.log(e);
      }
    }

    $(this).removeClass('disabled');
  })

  $('.post-anonymous-submit').on('click', async function(event) {
    event.preventDefault();

    $(this).addClass('disabled');

    const url = u.route('post_comment');
    const data = new FormData($('#post-form')[0]);

    data.append('score', score);
    data.append('anonymous', '1');

    if (score <= 0) {
      alert('未填寫分數');
    } else {
      try {
        const res = await u.$http.post(url, data);

        location.href = res.data.data;
      } catch (e) {
        console.log(e);
      }
    }

    $(this).removeClass('disabled');
  })

  $('.member-item__like').on('click', function(event) {
    event.preventDefault();

    const url = u.route('give_rating');

    const commentId = $(this).data('comment-id');

    u.$http.post(url, { comment_id: commentId })
      .then((res) => {
        if (res.data.data['task'] === 'create') {
          $(this).addClass('active');
          $(this).find('.rating-count').text(res.data.data['count']);
        }

        if (res.data.data['task'] === 'delete') {
          $(this).removeClass('active');
          $(this).find('.rating-count').text(res.data.data['count']);
        }
      });
  })

  $('#post-cancel').on('click', function() {
    $('#post-comment').hide();
  })
  
  $('.closeModal').on('click', function () {
    $('.modal').modal('hide');
  });

  const message = u.data('message');

  if(message) {
    scrollTo(message, false);
  }

  $('.j-info-action').on('click', (e) => {
    e.preventDefault();

    const $this = $(e.currentTarget);

    scrollTo($this.data('href'));
  });

  function scrollTo(e, moreHeight = false) {
    let height = $(e).offset().top;

    if (moreHeight) {
      height = height + $(window).height();
    }

    $("body, html").animate({
      scrollTop: height
    });
  }
})
